<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#products" ripple>{{ $t('Products') }}</v-tab>
      <v-tab href="#event" ripple>{{ $t('event') }}</v-tab>
    </v-tabs>
    <div v-if="currentView == 'products'">
      <products></products>
    </div>
    <div v-else-if="currentView == 'event'">
      <event></event>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Products from './Products'
import Event from './Event'
export default {
  data: function () {
    return {
      currentView: 'products'
    }
  },
  components: {
    Products,
    Event
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'products':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'products'
          break
      }
    } else {
      vm.currentView = 'products'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/main.vue